import React from "react";

import { cx, css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import {
  getCannotRenewTooltipTranslation,
  getCannotRenewTranslation,
  type CannotRenewReason,
} from "@/models/PatientRenewalInfoModel.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";
import { TextTooltip } from "@/uiKit/atoms/Tooltip.tsx";
import type { RenewalDatasource } from "@/uiKit/molecules/CarePlan/PatientRenewalButton.tsx";

export type PatientCannotRenewButtonProps = {
  cannotRenewReason: CannotRenewReason;
  dataSource: RenewalDatasource;
  className?: string;
};

export const PatientCannotRenewButton: React.FC<PatientCannotRenewButtonProps> = ({
  cannotRenewReason,
  dataSource,
  className,
}) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  const tooltipKey = getCannotRenewTooltipTranslation(cannotRenewReason);

  const button = (
    <Button
      id="disabled-renew-tls-button"
      variant="contained"
      data-action="care-plan.renewal.renew"
      data-source={dataSource}
      disabled
      className={cx(styles.container, className)}
    >
      {t(getCannotRenewTranslation(cannotRenewReason))}
    </Button>
  );

  if (!tooltipKey) {
    return button;
  }

  return (
    <TextTooltip popupId={`disabled-renew-tls-tooltip-${dataSource}`} placement="top" text={t(tooltipKey)}>
      {button}
    </TextTooltip>
  );
};

const makeStyles = () => ({
  container: css({}),
});
